import React from "react";
import "./style.css"
import Logo from "../../assets/icons/XL/Logo.svg"

function DaonLogo() {
  return (
    <div className="daon-logo-container">
      <img className="icon-x" src={Logo} alt="daon logo" />
      <div className="daon-logo-txt-container">
        <span className="daon-logo-txt-1">IdentityX</span>
        <span className="daon-logo-txt-2">Onboarding Registration</span>
      </div>
    </div>
  )
}

export default DaonLogo;